import { Polygon } from 'geojson';
import { useQuery } from 'react-query';
import { useAuth } from '../auth/AuthProvider';
import { InsightDashboard } from '../utils/interfaces';
import { getRequestHeaders, vake_api_server_url } from './helpers';

const queryKeyUseGetSanctionedVesselsQuery = ['queryKeyUseGetSanctionedVesselsQuery'];
export const useGetSanctionedVesselsQuery = () => {
    const { token } = useAuth();
    const url = `${vake_api_server_url}/actor-mode/sanctioned-vessels`;
    return useQuery<ActorModeVessel[]>(queryKeyUseGetSanctionedVesselsQuery, async () => {
        const res = await fetch(url, {
            credentials: 'include',
            headers: getRequestHeaders(token),
        });
        if (!res.ok) {
            throw new Error(res.statusText);
        }
        return await res.json();
    });
};

const queryKeyUseGetSanctionedVesselQuery = ['queryKeyUseGetSanctionedVesselQuery'];
export const useGetSanctionedVesselQuery = (vesselId: string) => {
    const { token } = useAuth();
    const url = `${vake_api_server_url}/actor-mode/sanctioned-vessels/${vesselId}`;
    return useQuery<ActorModeVessel>(queryKeyUseGetSanctionedVesselQuery, async () => {
        const res = await fetch(url, {
            credentials: 'include',
            headers: getRequestHeaders(token),
        });
        if (!res.ok) {
            throw new Error(res.statusText);
        }
        return await res.json();
    });
};

const queryKeyUseGetSanctionedVesselTagsQuery = (vesselId: string) => [
    'queryKeyUseGetSanctionedVesselTagsQuery',
    vesselId,
];
export const useGetSanctionedVesselTagsQuery = (vesselId: string) => {
    const { token } = useAuth();
    const url = `${vake_api_server_url}/actor-mode/sanctioned-vessels/${vesselId}/actions`;
    return useQuery<string[]>(queryKeyUseGetSanctionedVesselTagsQuery(vesselId), async () => {
        const res = await fetch(url, {
            credentials: 'include',
            headers: getRequestHeaders(token),
        });
        if (!res.ok) {
            throw new Error(res.statusText);
        }
        return await res.json();
    });
};

const queryKeyUseGetSanctionedVesselPathfinderQuery = (vesselId: string) => [
    'queryKeyUseGetSanctionedVesselPathfinderQuery',
    vesselId,
];
export const useGetSanctionedVesselPathfinderQuery = (vesselId: string) => {
    const { token } = useAuth();
    const url = `${vake_api_server_url}/actor-mode/sanctioned-vessels/${vesselId}/pathfinder`;
    return useQuery<Pathfinder[]>(queryKeyUseGetSanctionedVesselPathfinderQuery(vesselId), async () => {
        const res = await fetch(url, {
            credentials: 'include',
            headers: getRequestHeaders(token),
        });
        if (!res.ok) {
            throw new Error(res.statusText);
        }
        return await res.json();
    });
};

const queryKeyUseGetInsights = (vesselId: string, enabled: boolean, insideNorway: boolean) => [
    'queryKeyUseGetInsights',
    vesselId,
    enabled,
    insideNorway,
];
export const useGetInsights = (vesselId: string, enabled: boolean, insideNorway: boolean) => {
    const { token } = useAuth();
    const url = `${vake_api_server_url}/actor-mode/sanctioned-vessels/${vesselId}/insights/?inside_norway=${insideNorway}`;
    return useQuery<InsightDashboard[]>(
        queryKeyUseGetInsights(vesselId, enabled, insideNorway),
        async () => {
            const res = await fetch(url, {
                credentials: 'include',
                headers: getRequestHeaders(token),
            });
            if (!res.ok) {
                throw new Error(res.statusText);
            }
            return await res.json();
        },
        { enabled: enabled }
    );
};

const queryKeyUseGetEEZ = (country: string) => ['queryKeyUseGetEEZ', country];
export const useGetEEZ = (country: string) => {
    const { token } = useAuth();
    const url = `${vake_api_server_url}/actor-mode/sanctioned-vessels/eez/${country}`;
    return useQuery<Polygon>(queryKeyUseGetEEZ(country), async () => {
        const res = await fetch(url, {
            credentials: 'include',
            headers: getRequestHeaders(token),
        });
        if (!res.ok) {
            throw new Error(res.statusText);
        }
        return await res.json();
    });
};

const queryKeyUseGetNewestInsight = (vesselId: string) => ['queryKeyUseGetNewestInsight', vesselId];
export const useGetNewestInsight = (vesselId: string) => {
    const { token } = useAuth();
    const url = `${vake_api_server_url}/actor-mode/sanctioned-vessels/${vesselId}/newest-insight`;
    return useQuery<InsightDashboard>(queryKeyUseGetNewestInsight(vesselId), async () => {
        const res = await fetch(url, {
            credentials: 'include',
            headers: getRequestHeaders(token),
        });
        if (!res.ok) {
            throw new Error(res.statusText);
        }
        return await res.json();
    });
};
